module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "copy-week text-dark no-print"
  }, [(_vm.isShowCopyCalendarRotate) ? _c('CopyCalendarRotate', {
    attrs: {
      "calendarId": _vm.calid,
      "activeCalendarDate": _vm.activeCalendarDate
    }
  }) : [(!_vm.isShowCopyCalendarRotate) ? _c('button', {
    class: [{
        'do-bttn': _vm.activeCalendarDate
      },
      {
        'inactive': _vm.modal
      },
      {
        'hint--left hint--always': _vm.isJustCopied
      }
    ],
    attrs: {
      "aria-label": _vm.tooptipCopyWeek
    },
    on: {
      "click": _vm.getCopyDate
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + "\n      "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentDateIsNotWithinCalendarRange) ? _c('button', {
    class: {
      'do-bttn': _vm.activeCalendarDate
    },
    on: {
      "click": _vm.submitThisWeek
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.copycalendar.pasteThisWeek')) + "\n    ")]) : _vm._e()], _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInDown"
    }
  }, [(_vm.modal) ? _c('div', {
    staticClass: "week-picker"
  }, [_c('div', {
    staticClass: "week-picker__inner"
  }, [_c('div', {
    staticClass: "week-picker__header"
  }, [_c('div', {
    staticClass: "week-picker__header__left"
  }, [_c('h2', {
    staticClass: "text-blue"
  }, [_vm._v("\n              " + _vm._s(_vm.selectedWeeks.length) + "\n              "), (_vm.selectedWeeks.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.weekSelected')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.weeksSelected')))])]), _vm._v(" "), (_vm.schoolIsFromDenmark) ? _c('a', {
    staticClass: "label-link",
    attrs: {
      "target": "_blank",
      "href": "https://docendohelp.crisp.help/da/article/kopiering-af-uger-i-skemaerkalendere-1tka0r4/?bust=1737554247682"
    }
  }, [_c('label', {
    staticClass: "do-pill animateFast fadeInLeftCustom"
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("Bemærk: Kopierer kun brikker lagt i denne kalender")]), _vm._v(" "), _c('span', {
    staticClass: "icon-question3 marg-1-left"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle icon__bg-circle__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "week-picker__content flex"
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.weeks), function(week, index) {
    return _c('div', {
      key: week.serverDate,
      staticClass: "number hint--top",
      class: [{
        'isSelected': week.isSelected
      }, {
        'isCopyWeek': week.isCopyWeek
      }],
      attrs: {
        "aria-label": _vm._f("tooltipDate")(week.date)
      },
      on: {
        "click": function($event) {
          return _vm.toggleWeek(index)
        }
      }
    }, [_c('span', {
      class: {
        'isNow': week.isNow
      }
    }, [_vm._v("\n            " + _vm._s(week.weekNum) + "\n          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('ul', [_c('li', {
    staticClass: "sidebar__headline"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n                  "), _c('div', {
    staticClass: "no-tag",
    class: {
      'tag': !_vm.showStartPasteWeek
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("week")(_vm.startPasteWeek)) + "\n                    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showStartPasteWeek),
      expression: "!showStartPasteWeek"
    }],
    staticClass: "icon-cross2 pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.eraseStartDate.apply(null, arguments)
      }
    }
  })])])]), _c('li', [_c('span', {
    staticClass: "sidebar__clickable",
    on: {
      "click": _vm.selectAll
    }
  }, [_c('span', {
    staticClass: "bttn width-100 btn-trans"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sidebar__clickable",
    on: {
      "click": _vm.selectOddWeeks
    }
  }, [_c('span', {
    staticClass: "bttn width-100 btn-trans"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sidebar__clickable",
    on: {
      "click": _vm.selectEvenWeeks
    }
  }, [_c('span', {
    staticClass: "bttn width-100 btn-trans"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n               ")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sidebar__clickable",
    on: {
      "click": _vm.removeAllSelectedWeeks
    }
  }, [_c('span', {
    staticClass: "bttn btn-trans width-100 btn-remove"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n               ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "week-picker__footer"
  }, [_c('div', {
    staticClass: "delete-option"
  }, [_c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.deleteLessonsInSelectedWeeks')))]), _vm._v(" "), (_vm.calType === 'user') ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('vue2.copycalendar.absenceWillNotBeDeleted')) + ")")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteEvents),
      expression: "deleteEvents"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deleteEvents) ? _vm._i(_vm.deleteEvents, null) > -1 : (_vm.deleteEvents)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.deleteEvents,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deleteEvents = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deleteEvents = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deleteEvents = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "bttn--submit",
    class: {
      'inactive': _vm.noneSelected || _vm.notSubmit
    },
    on: {
      "click": _vm.submitWeeks
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])])]), _vm._v(" "), _c('left-panel', {
    attrs: {
      "deleteEvents": _vm.deleteEvents,
      "selectedWeeks": _vm.selectedWeeks,
      "calId": _vm.calid
    },
    on: {
      "load": _vm.setSubmit
    }
  })], 1) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d00a6530!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyCalendar/CopyCalendar.vue
// module id = 1819
// module chunks = 1